import { useTranslation } from 'react-i18next'
import {
  type ProjectRelationItem,
  type UserStandard,
} from '@/shared/hooks/api/userStandards'
import { Card, CardHeader, CardTitle } from '@/components/ui/card'

type StandardProjectRelationSectionProps = {
  standard: UserStandard
}

export function StandardProjectRelationSection({
  standard,
}: StandardProjectRelationSectionProps) {
  const { t } = useTranslation('standardsLibrary')
  const projectRelation = standard.projectRelation

  if ((projectRelation?.length ?? 0) === 0) {
    return null
  }

  return (
    <Card>
      <CardHeader className='mb-2'>
        <CardTitle>{t('detail.projectRelation')}</CardTitle>
      </CardHeader>
      <ul className='space-y-2 divide-y'>
        {projectRelation!.map((item: ProjectRelationItem, index: number) => (
          <li key={index} className='px-4 pb-2 whitespace-pre-wrap'>
            {(item.value?.trim() || item.relationOptionValue?.trim()) && (
              <p className='flex items-center gap-2'>
                {item.value?.trim() ? (
                  <span className='font-medium'>{item.value}</span>
                ) : null}
                {item.relationOptionValue?.trim() ? (
                  <span className='text-muted-foreground'>
                    ({item.relationOptionValue})
                  </span>
                ) : null}
              </p>
            )}
            {item.description?.trim() ? (
              <div className='mt-1 text-sm text-muted-foreground'>
                {item.description}
              </div>
            ) : null}
          </li>
        ))}
      </ul>
    </Card>
  )
}
